/* eslint-disable no-nested-ternary */
// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  .coupon_form_container {
    padding: 18px 16px 12px 14px;
    ${(props) =>
      props.spc
        ? `padding:8px 0px 14px;
          @media ${props.theme.mediaQuery.medium}{width:310px;
    height:30px;}
   `
        : 'box-sizing: border-box;'}
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-left: 0px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => props.spc && 'width:auto; margin-left:0px;'}
    }

    .coupon_form_heading {
      justify-content: space-between;
      margin: 0px;
      margin-bottom: ${(props) => (props.spc ? '0px' : '18px')};
      display: ${(props) => (props.spc ? 'none' : 'flex')};
      text-transform: capitalize;
    }
    .coupon_need_help_link {
      padding-left: 12px;
      padding-left: 8px;
      text-decoration: underline;
      cursor: pointer;
    }
    .coupon_submit_form {
      display: flex;
      flex: 1;
      ${(props) =>
        props.spcBag
          ? `padding:8px 0px 5px;
       `
          : 'border: 0.8px dashed'}
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        flex-direction: ${(props) => (props.spc || props.spcBag ? 'row' : 'column')};
      }
    }

    .input-fields-wrapper {
      padding-right: 8px;
      flex: 1;
      .TextBox__label {
        ${(props) =>
          props.spcBag ? `font-size: 12px;  background-color: ${props.theme.colors.WHITE};  ` : ''}
      }
      ${(props) =>
        props.spcBag &&
        `
      .TextBox__placeholder{
        top:12px;
      }`}
      ${(props) =>
        props.spc
          ? `padding-right:0px;margin:0px;
      .TextBox__placeholder{
        top:8px;
        font-size:${props.theme.typography.fontSizes.fs12};
        @media ${props.theme.mediaQuery.smallOnly}{
          top:20px;
        }
        @media (max-width: ${props.theme.breakpoints.small}){
          top:15px;
        }
      }
      .TextBox__label.nonActive{
        top:-8px;
        font-size:${props.theme.typography.fontSizes.fs10};
      }
      `
          : ''}
      &.textbox_validation_success .checkmark-container {
        ${(props) => (props.spcBag ? `top: 13px; right: -18px;` : '')}
        ${(props) =>
          props.spc
            ? `top: 8px;right: 32px; @media ${props.theme.mediaQuery.smallOnly}{
                top: 21px;right: 12px;}`
            : ''}
      }
      .TextBox__label.nonActive {
        ${(props) =>
          props.spcBag
            ? `top:-4px;
            font-size:${props.theme.typography.fontSizes.fs10};`
            : ''}
      }

      .TextBox__input:focus ~ .TextBox__label {
        ${(props) => (props.newBag ? `top:-4px;` : '')}
      }

      input {
        border-radius: 6px;
        height: ${(props) => (props.newBag ? `40px;` : '16px')};
        margin-bottom: 0;
        ${(props) =>
          props.spc
            ? `height: 28px;
        width: 190px;margin-right:8px;
        @media ${props.theme.mediaQuery.smallOnly}{
          height: 35px;
        width:90%;
        margin-top:8px;
        }
        @media (max-width: ${props.theme.breakpoints.small}){
          margin-top:8px;
          height:35px;
        }
        `
            : 'margin-top: 1px;'}

        ${(props) => (props.spcBag ? `height:5px;` : '')}
      }
    }

    .coupon_submit_button {
      height: 42px;
      width: 102px;
      border-radius: 6px;
      ${(props) => (props.spcBag ? '' : `margin-top: 8px;`)};
      cursor: default;
      ${(props) =>
        props.spc
          ? `padding:0px;background-color:${props.theme.colorPalette.gray[900]};color:${props.theme.colors.WHITE};`
          : ''}
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs10};
      }
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        width: 162px;
        align-self: center;
        ${(props) =>
          props.spc
            ? `margin-top:0px;
          height:32px;
          min-height:30px;`
            : ''};
      }
      ${(props) => (props.spc ? `font-size: ${props.theme.typography.fontSizes.fs14};` : '')}
      @media ${(props) => props.theme.mediaQuery.medium} {
        ${(props) =>
          props.spc
            ? `
            height: 32px;
            width: 80px;
            min-height:30px;
            font-size: ${props.theme.typography.fontSizes.fs10};
            `
            : `
            height: 51px;
            width: 120px;
            `}
        ${(props) => (props.spcBag ? `margin-top: 0; width: 80px;` : `margin-top: 18px;`)}
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        ${(props) =>
          props.spcBag || props.spc
            ? `height: 36px; width: 80px;`
            : `height: 51px;
        width: 120px;`}
        margin-top: 0;
        ${(props) => (props.spcBag ? ` height:36px; width: 80px;` : '')}
      }
      ${(props) =>
        props.spcBag
          ? `padding:0px;background-color:${props.theme.colors.BUTTON.BLACK.NORMAL};border-radius: 6px; height:36px;color:${props.theme.colors.WHITE};`
          : ''}
    }

    .TextBox__input {
      ${(props) =>
        props.spc
          ? `
          padding: ${props.theme.spacing.ELEM_SPACING.XXXS};
          padding-left: ${props.theme.spacing.ELEM_SPACING.XS};
          padding-right: ${props.theme.spacing.ELEM_SPACING.XS};
          font-size:${props.theme.typography.fontSizes.fs16};
          @media ${props.theme.mediaQuery.large}{border-radius:0px;}
        `
          : ''}
      ${(props) =>
        props.spcBag
          ? `border-radius: 0; height:36px;
          font-size:${props.theme.typography.fontSizes.fs12}
          `
          : `border-bottom: 1px solid ${props.theme.colors.FOOTER.DIVIDER};`}
      ${(props) => (props.newBag ? `box-sizing: border-box; padding: 16px;` : '')}
    }
    .textbox_validation_success .TextBox__input {
      ${(props) => `border: 1px solid ${props.theme.colorPalette.gray[600]};`}
    }
    .textbox-loader-cont > .loading:after {
      ${(props) => props.spc && ` left: 0px;top: 4px;`}
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        ${(props) => props.spc && ` left: 12px;top: 0px`}
      }
    }
    .coupon_error_message {
      ${(props) => (props.spcBag ? `background-color: ${props.theme.colors.WHITE}` : ``)}
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        padding: 0px 15px 10px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        padding-right: 2px;
      }
    }
  }
`;
